var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1619 19.9417C12.0173 19.9045 10.0727 19.9045 8.0963 19.8208C6.61265 19.7733 5.13246 19.6461 3.66184 19.4398C1.78537 19.1518 0.663128 17.8833 0.372344 15.9504C0.0575688 13.6202 -0.0579706 11.2664 0.0270374 8.9157C0.0270374 7.69369 0.117907 6.46239 0.208778 5.24039C0.255413 4.57051 0.361872 3.9064 0.526823 3.25636C0.688036 2.52661 1.06723 1.86621 1.61186 1.36669C2.15648 0.867177 2.83956 0.553282 3.56643 0.468514C4.98437 0.242506 6.41604 0.118298 7.85095 0.0968004C11.0496 0.0193601 14.2482 -0.011616 17.4468 0.00387202C19.396 0.00387202 21.3452 0.166497 23.2898 0.273364C23.8059 0.305846 24.3191 0.375718 24.8255 0.482453C25.5413 0.595486 26.2037 0.937323 26.7179 1.45899C27.2321 1.98065 27.5717 2.65536 27.6879 3.38646C27.9615 4.85608 28.1135 6.34666 28.1422 7.84238C28.2755 10.3428 28.198 12.8503 27.9105 15.3371C27.8602 15.7836 27.7797 16.2261 27.6697 16.6613C27.5084 17.3877 27.1315 18.0454 26.5906 18.5444C26.0498 19.0435 25.3714 19.3594 24.6483 19.4491C23.2194 19.6606 21.7797 19.7863 20.3365 19.8255C18.2011 19.8859 16.0974 19.8998 14.1619 19.9417ZM11.4176 14.4078L18.4827 9.9565L11.4176 5.49594V14.4078Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.119e2b7a8518a21f23c968a536953eca.svg";
export { ForwardRef as ReactComponent };